import AgencyUserApiService from "@api-services/user/AgencyUserApiService";
import { StorageStateKeysEnum } from "@utils/storage";
import { observable, action } from "mobx";
import { localizationService } from "@state";
import type { RootStore } from "@state/stores/types";
import { analyticsTracker } from "@utils/analytics";

class OnboardingNewsletterStore {
	@observable isActive: boolean = false;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	showPopup() {
		this.isActive = true;

		this.rootStore.localStorageProvider.set(
			StorageStateKeysEnum.ONBOARDING_NEWSLETTER_POPUP,
			JSON.stringify(true)
		);
	}

	@action.bound
	hidePopup() {
		this.isActive = false;
	}

	@action.bound
	async acceptNewsletter(email: string) {
		try {
			await AgencyUserApiService.subscribeToNewsletter(email);
			analyticsTracker.trackNewsletterSubscribed(email);
			this.hidePopup();
		} catch (err) {
			if (err?.errorCode == 400126) {
				this.rootStore.notificationStore.error(
					localizationService.t(
						"USER.POPUPS.ONBOARDING_WELCOME_POPUPS.NEWSLETTER.USER_WITH_EMAIL_ALREADY_EXISTS"
					)
				);
			} else {
				this.rootStore.notificationStore.error(
					localizationService.t("ERROR.TITLE")
				);
			}
			return false;
		}
	}
}

export default OnboardingNewsletterStore;
